import { Component } from '@angular/core';

@Component({
  selector: 'app-full-house',
  templateUrl: './full-house.component.html',
  styleUrls: ['./full-house.component.scss']
})
export class FullHouseComponent {

}
